app.apply(app.area, {
  init: function init(container) {
    app.plugins.init(container);
    app.plugins.initPaymentAdjustment(container);
    app.plugins.initTotals(container);
    app.plugins.initDebts(container);
  }
});